import { omit as _omit } from '@lodash';
import config from '@config';
import * as Sentry from '@sentry/vue';
import ValidationError from '@errors/network/ValidationError';

export function logError(e: any) {
    console.log(e);
    if (config.environment.isQa) {
        Sentry.captureException(e);
    }
    if (!e.isLogged && !(e instanceof ValidationError)) {
        if (config.environment.isProduction) {
            Sentry.captureException(e);
        } else if (!config.environment.isTest) {
            console.info(e);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/errors.ts